import { render, staticRenderFns } from "./periodicityList.vue?vue&type=template&id=2375908a&scoped=true"
import script from "./periodicityList.vue?vue&type=script&lang=js"
export * from "./periodicityList.vue?vue&type=script&lang=js"
import style0 from "./periodicityList.vue?vue&type=style&index=0&id=2375908a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2375908a",
  null
  
)

export default component.exports